module.exports = require('date-fns/endOfWeek').endOfWeek;
